const ContactBox = ({title, sub,icon})=> {
    return(
        <div className="flex items-center gap-2 sm:w-1/2">
            <div
            className="bg-[#E1E1E1] w-[60px] h-[60px] rounded-[15px]
            flex justify-center items-center"
            >
                <img src={icon}
                className="w-[25px] object-contain"
                />
            </div>
            <div>
                <p className="font-medium">
                {title}
            </p>
            <p>
                {sub}
            </p>
            </div>
        </div>
    )
}
export default ContactBox